// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import { LogLevel } from '../app/log-levels';

export const environment = {
  production: true,
  allowedImpersonateOrigins: ['https://admin.simplecitizen.app'],
  CLIENT_MAX_BODY_SIZE: 12,
  endpoints: {
    basePath: '/v2/api',
    apiTokenAuth: '/v2/api-token-auth/',
    meUser: '/v2/api/users/me/',
    resetPassword: '/v2/api/reset-password/',
    checkValidationKey: '/v2/api/check-validation/',
    setNewPassword: '/v2/api/reset/',
    dynamicConfig: '/v2/api/dynamic-config/',
    reporting: '/v2/api/reporting/',
    userApi: '/v2/api/users/',
    paymentsApi: '/v2/api/payments/',
    applicationTypeApi: '/v2/api/application-type/',
    questionnaireToken: '/v2/api/questionnaire-token/',
    savedReportApi: '/v2/api/saved-report/',
    reportScheduleApi: '/v2/api/report-schedule/',
    scEvent: '/v2/api/sc-event/',
    appCaseApi: '/v2/api/application-case/',
    logout: '/v2/logout/',
    impersonate: '/v2/api/users/impersonate/',
    gql: '/v2/gql',
    gqlv3: '/v3/gql',
    gqlInternal: '/v3/internal/gql',
    checkGuestToken: '/v2/api/check-guest-token/',
    checkSocial: '/auth/check-social/',
    passwordRequirement: '/v2/api/password-validation-requirements/',
    extTokens: '/api/v1/token/',
    startImpersonation: '/v3/api/start-impersonation/',
    stopImpersonation: '/v3/api/stop-impersonation/',
    sessionStatus: '/v2/api/session-status/',
    backendVersionApi: '/api/backend-version-info/',
    pollingTaskUrl: 'v2/api/reporting/poll-task/',
    qctXml: 'v2/api/preview-questionnaire',
    s3InitiateUpload: '/v3/s3/initiate_upload',
    s3UploadChunk: '/v3/s3/upload_chunk',
    s3CompleteUpload: '/v3/s3/complete_upload',
    fnStartApp: '/v2/api/application-case/start_app/',
    crossDeviceUpload: '/cross-device-upload'
  },
  keys: {
    stripePublicKey:
      'pk_test_51RPTSrPBfg3rqQUA9rgEmEjlkF3FidLh6qVtctKLtF0VOwAC4tyHOJtjATVLkRo667eOhtH9M3C98goYbElsZwdp00ZRrGk30n',
    googleMaps: 'AIzaSyBlV4gHtVrNCgblya1Ka4Y3Ew9AaHslkhg',
    gtm: 'GTM-PDFK9H',
    mixPanel: 'daabf40e214a033addc4e63cf5e4e2e5',
    weglot: 'wg_d527f379dac4d2adacc14a912b6f0b4e4'
  },
  sentryOpts: {
    dsn: 'https://0803990560a940159c5fd53a7e6abc76@errors.simplecitizen.net/9',
    release: 'ea444ccad9e1e16af49289843a3a1b7df041d618',
    environment: 'staging-consumer'
  },
  contentSquare: {
    scriptUrl: 'https://t.contentsquare.net/uxa/190b0e1b3d335.js',
    postPurchaseCookie: 'sc_cs_post_purchase_stg'
  },
  review: false,
  secureCookie: true,
  cookieDomain: null,
  csrfCookieName: 'staging_csrftoken',
  logLevel: LogLevel.ALL,
  signUpUrl: 'https://start-staging.simplecitizen.com/',
  version: 'ea444ccad9e1e16af49289843a3a1b7df041d618'
};
